(function () {
  let isOpen = false;
  let activeTabIndex = 0;
  let selectedOption = "most_recent";
  let selectedOptionLabel = "Most Recent";
  let selectedCategory = "view all";
  const visibleCounts = {};

  const wrapper = document.getElementById("press-sort-wrapper");
  const display = document.getElementById("press-sort-display");
  const optionsList = document.getElementById("press-sort-options");
  const tabs = document.querySelectorAll("#press-filter-tabs .tab");
  const arrow = document.querySelector(
    "#press-sort-wrapper .custom-select-arrow",
  );

  function syncTailwindClasses() {
    if (arrow) {
      arrow.classList.toggle("rotate-180", isOpen);
    }

    if (optionsList) {
      optionsList.classList.toggle("hidden", !isOpen);
      optionsList.classList.toggle("block", isOpen);
      optionsList.querySelectorAll("li").forEach(function (li) {
        const selected = li.classList.contains("selected");
        li.classList.toggle("bg-[#1d1d1d]", selected);
        li.classList.toggle("text-white", selected);
        li.classList.toggle("text-[#333]", !selected);
        li.classList.toggle("hover:bg-[#1d1d1d]", selected);
        li.classList.toggle("hover:text-white", selected);
        li.classList.toggle("hover:bg-[#f5f5f5]", !selected);
        li.classList.toggle("hover:text-[#333]", !selected);
      });
    }

    tabs.forEach(function (tab) {
      const active = tab.classList.contains("active");
      tab.classList.toggle("text-ink", active);
      tab.classList.toggle("opacity-100", active);
      tab.classList.toggle("text-ink-faint", !active);
      tab.classList.toggle("opacity-70", !active);
    });
  }

  function normalizeTag(tag) {
    if (!tag) {
      return "";
    }
    tag = tag.trim().toLowerCase();
    if (tag.endsWith("s")) {
      tag = tag.slice(0, -1);
    }
    return tag;
  }

  function toggleDropdown() {
    isOpen = !isOpen;
    wrapper.classList.toggle("open", isOpen);
    syncTailwindClasses();
  }

  function closeDropdown() {
    isOpen = false;
    wrapper.classList.remove("open");
    syncTailwindClasses();
  }

  function selectOption(value, label) {
    selectedOption = value;
    selectedOptionLabel = label;
    closeDropdown();
    if (display) {
      display.textContent = label;
    }
    if (optionsList) {
      optionsList.querySelectorAll("li").forEach(function (li) {
        li.classList.toggle("selected", li.dataset.value === value);
      });
      syncTailwindClasses();
    }
    updateUrl();
    filterArticles();
  }

  function setActiveTab(index, tabLabel) {
    activeTabIndex = index;
    selectedCategory = tabLabel.toLowerCase();
    const tagKey = normalizeTag(selectedCategory);
    if (visibleCounts[tagKey] === undefined) {
      visibleCounts[tagKey] = window.initialVisibleCount || 6;
    }
    tabs.forEach(function (tab, i) {
      tab.classList.toggle("active", i === index);
    });
    syncTailwindClasses();
    updateUrl();
    filterArticles();
  }

  function updateUrl() {
    const url = new URL(window.location.href);
    if (selectedCategory === "view all") {
      url.searchParams.delete("tag");
    } else {
      url.searchParams.set("tag", selectedCategory);
    }
    if (selectedOption) {
      url.searchParams.set("sort", selectedOption);
    }
    window.history.pushState({}, "", url);
    window.dispatchEvent(new Event("popstate"));
  }

  function filterArticles() {
    const allArticles = document.querySelectorAll(".artical-main");
    const selectedNormalized = normalizeTag(selectedCategory);

    allArticles.forEach(function (article) {
      const articleTag = normalizeTag(article.dataset.tag);
      const matches =
        selectedNormalized === "view all" || articleTag === selectedNormalized;
      article.style.display = matches ? "block" : "none";
    });

    const container = document.querySelector(".article-main-wrapper");
    if (!container) {
      return;
    }

    const visibleArticles = Array.from(
      container.querySelectorAll(".artical-main"),
    ).filter(function (el) {
      return el.style.display !== "none";
    });

    if (selectedOption === "most_recent" || selectedOption === "") {
      visibleArticles.sort(function (a, b) {
        return (
          new Date(b.querySelector(".artical-date").innerText) -
          new Date(a.querySelector(".artical-date").innerText)
        );
      });
    } else if (selectedOption === "oldest") {
      visibleArticles.sort(function (a, b) {
        return (
          new Date(a.querySelector(".artical-date").innerText) -
          new Date(b.querySelector(".artical-date").innerText)
        );
      });
    } else if (selectedOption === "title_a_z") {
      visibleArticles.sort(function (a, b) {
        return a
          .querySelector(".artical-description")
          .innerText.toLowerCase()
          .localeCompare(
            b.querySelector(".artical-description").innerText.toLowerCase(),
          );
      });
    } else if (selectedOption === "title_z_a") {
      visibleArticles.sort(function (a, b) {
        return b
          .querySelector(".artical-description")
          .innerText.toLowerCase()
          .localeCompare(
            a.querySelector(".artical-description").innerText.toLowerCase(),
          );
      });
    }

    visibleArticles.forEach(function (article) {
      container.appendChild(article);
    });

    showLimitedArticles();
  }

  function showLimitedArticles() {
    const allArticles = Array.from(document.querySelectorAll(".artical-main"));
    const selectedNormalized = normalizeTag(selectedCategory);
    const visibleCount =
      visibleCounts[selectedNormalized] || window.initialVisibleCount || 6;

    const filteredArticles = allArticles.filter(function (article) {
      const articleTag = normalizeTag(article.dataset.tag);
      return (
        selectedNormalized === "view all" || articleTag === selectedNormalized
      );
    });

    filteredArticles.forEach(function (article, index) {
      article.style.display = index < visibleCount ? "block" : "none";
    });

    allArticles.forEach(function (article) {
      const articleTag = normalizeTag(article.dataset.tag);
      if (
        selectedNormalized !== "view all" &&
        articleTag !== selectedNormalized
      ) {
        article.style.display = "none";
      }
    });

    const loadMoreWrapper = document.getElementById("load-more-wrapper");
    if (loadMoreWrapper) {
      loadMoreWrapper.style.display =
        visibleCount < filteredArticles.length ? "block" : "none";
    }
  }

  function loadMoreHandler() {
    const tagKey = normalizeTag(selectedCategory);
    const currentCount =
      visibleCounts[tagKey] || window.initialVisibleCount || 6;
    visibleCounts[tagKey] = currentCount + (window.initialVisibleCount || 6);
    showLimitedArticles();
  }

  function init() {
    const urlParams = new URLSearchParams(window.location.search);
    const tagFromUrl = urlParams.get("tag");
    const sortFromUrl = urlParams.get("sort");

    if (tagFromUrl) {
      selectedCategory = tagFromUrl.toLowerCase();
      const normalizedTagFromUrl = normalizeTag(selectedCategory);
      const tabArray = Array.from(tabs);
      const foundIndex = tabArray.findIndex(function (tab) {
        return normalizeTag(tab.dataset.tabLabel) === normalizedTagFromUrl;
      });
      activeTabIndex = foundIndex !== -1 ? foundIndex : 0;
    }

    tabs.forEach(function (tab, i) {
      tab.classList.toggle("active", i === activeTabIndex);
    });
    syncTailwindClasses();

    const allOptions = optionsList
      ? Array.from(optionsList.querySelectorAll("li"))
      : [];
    let defaultOption = allOptions.find(function (li) {
      return li.dataset.value === sortFromUrl;
    });
    if (!defaultOption) {
      defaultOption =
        allOptions.find(function (li) {
          return li.dataset.label.toLowerCase().includes("most recent");
        }) || allOptions[0];
    }
    if (defaultOption) {
      selectedOption = defaultOption.dataset.value;
      selectedOptionLabel = defaultOption.dataset.label;
      if (display) {
        display.textContent = selectedOptionLabel;
      }
      defaultOption.classList.add("selected");
      syncTailwindClasses();
    }

    const tagKey = normalizeTag(selectedCategory);
    visibleCounts[tagKey] = window.initialVisibleCount || 6;

    filterArticles();

    if (wrapper) {
      wrapper.addEventListener("click", function (e) {
        toggleDropdown();
      });
    }

    if (optionsList) {
      optionsList.addEventListener("click", function (e) {
        const li = e.target.closest("li");
        if (li) {
          e.stopPropagation();
          selectOption(li.dataset.value, li.dataset.label);
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        setActiveTab(index, tab.dataset.tabLabel);
      });
    });

    const loadMoreButton = document.getElementById("load-more-button");
    if (loadMoreButton) {
      loadMoreButton.addEventListener("click", loadMoreHandler);
    }

    document.addEventListener("click", function (e) {
      if (wrapper && !wrapper.contains(e.target)) {
        closeDropdown();
      }
    });

    syncTailwindClasses();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
